import { render } from "./HeaderImageBoxStart.vue?vue&type=template&id=5a0b55f2"
import script from "./HeaderImageBoxStart.vue?vue&type=script&lang=ts"
export * from "./HeaderImageBoxStart.vue?vue&type=script&lang=ts"

import "./HeaderImageBoxStart.vue?vue&type=style&index=0&id=5a0b55f2&lang=scss"
script.render = render

export default script